<script setup lang="ts">
import { useContentStore } from '~/stores/content'
import ServiceFeatureCard from '~/components/cards/ServiceFeatureCard.vue'
const $content = useContentStore()

</script>

<template>
<Frame class="sec-services" w="max-w-92% tm:max-w-85% mx-auto ">

  <div class="sec-header">
    <div class="sec-title flex flex-col dm:flex-row g-1.5">
      <h2 class="fs-4 t:fs-5! d:fs-6! fw-600 gmb-2">Our Key Services</h2>
      <p class="fs-05 d:fs-1 text-gray-600 dark:text-gray-350 max-w-800px mx-auto text-center">
        We are more than a supplier of products. We offer a range of services to help you maintain the perfect environment for your business. 
      </p>
    </div>
  </div>

  <div class="sec-cards gc-300px">
    <ServiceFeatureCard v-for="service in $content.services" :key="service.name" :service="service" />
  </div>
</Frame>
</template>

<style lang="scss" scoped>

.sec-services {

  padding: gr(2) 0;

}
 .sec-header {

>.sec-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: gr(2) 0;

  > h2 {
    color: #05a6ce;
    font-weight: 400;
    line-height: gr(2);
    font-family: var(--font-secondary);
    margin: 0;
  }

  > p {
    font-size: fs(1);
    font-weight: 400;
    text-align: center;
    color: var(--primaryTextColor);

    @include mq($from: dm) {
      text-align: left;
    }
  }
}

}
</style>